/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Motivation_Example_2Inputs */

const en_us2_onboarding_motivation_example_2 = /** @type {(inputs: Onboarding_Motivation_Example_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My back hurts by the end of a work day and I want that to stop.`)
};

const pt_br2_onboarding_motivation_example_2 = /** @type {(inputs: Onboarding_Motivation_Example_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minhas costas doem no fim do dia de trabalho e quero que isso pare.`)
};

const es_419_onboarding_motivation_example_2 = /** @type {(inputs: Onboarding_Motivation_Example_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me duele la espalda al final del día de trabajo y quiero que pare.`)
};

const pt_pt2_onboarding_motivation_example_2 = /** @type {(inputs: Onboarding_Motivation_Example_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As costas doem-me no fim do dia de trabalho e quero que isso pare.`)
};

const fr_fr2_onboarding_motivation_example_2 = /** @type {(inputs: Onboarding_Motivation_Example_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`J'ai mal au dos à la fin de ma journée de travail et je veux que ça s'arrête.`)
};

const de_de2_onboarding_motivation_example_2 = /** @type {(inputs: Onboarding_Motivation_Example_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mein Rücken tut am Ende eines Arbeitstags weh, und das soll aufhören.`)
};

const it_it2_onboarding_motivation_example_2 = /** @type {(inputs: Onboarding_Motivation_Example_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fine giornata di lavoro mi fa male la schiena e voglio che smetta.`)
};

/**
* | output |
* | --- |
* | "My back hurts by the end of a work day and I want that to stop." |
*
* @param {Onboarding_Motivation_Example_2Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_motivation_example_2 = /** @type {((inputs?: Onboarding_Motivation_Example_2Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Motivation_Example_2Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_motivation_example_2(inputs)
	if (locale === "es-419") return es_419_onboarding_motivation_example_2(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_motivation_example_2(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_motivation_example_2(inputs)
	if (locale === "de-DE") return de_de2_onboarding_motivation_example_2(inputs)
	if (locale === "it-IT") return it_it2_onboarding_motivation_example_2(inputs)
	return en_us2_onboarding_motivation_example_2(inputs)
});
export { onboarding_motivation_example_2 as "onboarding.motivation.example_2" }